import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          阅读优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么百万漫迷选择古古漫画网
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/70 p-6 text-center group transition-all duration-200 hover:border-primary-200 hover:bg-background-50"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center text-primary-500 text-2xl group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={item.icon} />
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2.5">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}